import { render, staticRenderFns } from "./IconExit.vue?vue&type=template&id=2f5d3f38&"
import script from "./IconExit.vue?vue&type=script&lang=js&"
export * from "./IconExit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2f5d3f38')) {
      api.createRecord('2f5d3f38', component.options)
    } else {
      api.reload('2f5d3f38', component.options)
    }
    module.hot.accept("./IconExit.vue?vue&type=template&id=2f5d3f38&", function () {
      api.rerender('2f5d3f38', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/icons/IconExit.vue"
export default component.exports